import { useEffect } from "react";

type UseTextSelectionOptions = {
  containerRef: React.RefObject<HTMLDivElement | null>;
  pageRefs: React.MutableRefObject<(HTMLDivElement | null)[]>;
  snipMode: boolean;
  onTextSelected?: (text: string, pageNumber?: number) => void;
};

export function useTextSelection({
  containerRef,
  pageRefs,
  snipMode,
  onTextSelected,
}: UseTextSelectionOptions) {
  useEffect(() => {
    if (snipMode) return;

    const container = containerRef.current;
    if (!container) return;

    const handleMouseUp = () => {
      const selection = window.getSelection();
      const text = selection?.toString().trim();
      if (!text) return;

      let pageNumber: number | undefined;
      const anchorNode = selection?.anchorNode;
      if (anchorNode) {
        const el =
          anchorNode instanceof Element ? anchorNode : anchorNode.parentElement;
        const pageContainer = el?.closest(".page-container");
        if (pageContainer) {
          const idx = pageRefs.current.findIndex((ref) => ref === pageContainer);
          if (idx >= 0) pageNumber = idx + 1;
        }
      }

      onTextSelected?.(text, pageNumber);
    };

    container.addEventListener("mouseup", handleMouseUp);
    return () => container.removeEventListener("mouseup", handleMouseUp);
  }, [snipMode, onTextSelected, containerRef, pageRefs]);
}
